import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, resource }) =>
    present(
      repository
        .saveCalendarExportLink(planzone, resource)
        .then((link) => ({ planzone, link }))
        .catch(() => Promise.reject(planzone)),
    );
}

export type { Interactor };

export { createInteractor };
